import { IContentModel } from "models/dto/ZoomiLxp/Models/ContentModels/IContentModel";
import { ISaveEventCourseItemHistoryModel } from "../models/dto/ZoomiLxp/Models/EventModels/ISaveEventCourseItemHistoryModel";
import { EventTypes } from "models/dto/ZoomiLxp/Utilities/Enumerations/EventTypes";
import { useAppStore } from "store";

export const useScormNav = (prev: () => void, next: () => void, content?: IContentModel) => {
	const { contentStore, toasterStore, coursesStore } = useAppStore();
	const handleNext = async () => {
		if (!coursesStore.wasScormStartSent) {
			const startData: ISaveEventCourseItemHistoryModel = {
				sessionId: contentStore?.sessionId ?? 0,
				eventType: EventTypes.Start,
				payload: "",
			};
			const endData: ISaveEventCourseItemHistoryModel = {
				sessionId: contentStore?.sessionId ?? 0,
				eventType: EventTypes.End,
				payload: "",
			};
			contentStore.stopKeepAlive();
			if (content?.completeByNextButton) {
				const completeData: ISaveEventCourseItemHistoryModel = {
					sessionId: contentStore?.sessionId ?? 0,
					eventType: EventTypes.Complete,
					payload: "",
				};
				contentStore
					.sendEventCourseItemHistory(startData)
					.then(() => contentStore.sendEventCourseItemHistory(endData).then(
						() => contentStore.sendEventCourseItemHistory(completeData)
					).then(
						() => {
							coursesStore.updateActiveCourseItemToCompleted();
							next();
						}
					).catch((err) => toasterStore.showErrorMessage(err)));
			} else {
				contentStore
					.sendEventCourseItemHistory(startData)
					.then(() => contentStore.sendEventCourseItemHistory(endData).then(
						() => next()
					).catch((err) => toasterStore.showErrorMessage(err)));
			}
		} else {
			const data: ISaveEventCourseItemHistoryModel = {
				sessionId: contentStore?.sessionId ?? 0,
				eventType: EventTypes.End,
				payload: "",
			};
			contentStore.stopKeepAlive();
			if (content?.completeByNextButton) {
				const completeData: ISaveEventCourseItemHistoryModel = {
					sessionId: contentStore?.sessionId ?? 0,
					eventType: EventTypes.Complete,
					payload: "",
				};
				contentStore
					.sendEventCourseItemHistory(data).then(() => contentStore.sendEventCourseItemHistory(completeData))
					.then(() => {
						coursesStore.updateActiveCourseItemToCompleted();
						next();
					})
					.catch((err) => toasterStore.showErrorMessage(err));
			} else {
				contentStore
					.sendEventCourseItemHistory(data)
					.then(() => next())
					.catch((err) => toasterStore.showErrorMessage(err));
			}
		}
	};

	const handlePrev = async () => {
		if (!coursesStore.wasScormStartSent) {
			const startData: ISaveEventCourseItemHistoryModel = {
				sessionId: contentStore?.sessionId ?? 0,
				eventType: EventTypes.Start,
				payload: "",
			};
			const endData: ISaveEventCourseItemHistoryModel = {
				sessionId: contentStore?.sessionId ?? 0,
				eventType: EventTypes.End,
				payload: "",
			};
			contentStore.stopKeepAlive();
			if (content?.completeByNextButton) {
				const completeData: ISaveEventCourseItemHistoryModel = {
					sessionId: contentStore?.sessionId ?? 0,
					eventType: EventTypes.Complete,
					payload: "",
				};
				contentStore
					.sendEventCourseItemHistory(startData)
					.then(() => contentStore.sendEventCourseItemHistory(endData).then(
						() => contentStore.sendEventCourseItemHistory(completeData)
					).then(
						() => {
							coursesStore.updateActiveCourseItemToCompleted();
							prev();
						}
					).catch((err) => toasterStore.showErrorMessage(err)));
			} else {
				contentStore
					.sendEventCourseItemHistory(startData)
					.then(() => contentStore.sendEventCourseItemHistory(endData).then(
						() => prev()
					).catch((err) => toasterStore.showErrorMessage(err)));
			}
		} else {
			const data: ISaveEventCourseItemHistoryModel = {
				sessionId: contentStore?.sessionId ?? 0,
				eventType: EventTypes.End,
				payload: "",
			};
			contentStore.stopKeepAlive();
			if (content?.completeByNextButton) {
				const completeData: ISaveEventCourseItemHistoryModel = {
					sessionId: contentStore?.sessionId ?? 0,
					eventType: EventTypes.Complete,
					payload: "",
				};
				contentStore
					.sendEventCourseItemHistory(data).then(() => contentStore.sendEventCourseItemHistory(completeData))
					.then(() => {
						coursesStore.updateActiveCourseItemToCompleted();
						prev();
					})
					.catch((err) => toasterStore.showErrorMessage(err));
			} else {
				contentStore
					.sendEventCourseItemHistory(data)
					.then(() => prev())
					.catch((err) => toasterStore.showErrorMessage(err));
			}
		}
	};

	return { handleNext, handlePrev };
};
